import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

import { ArrowLink } from '../Common/Links';
import * as styles from './LogoSection.module.scss';
import PageSection from './PageSection';

const LogoSection = ({ section }) => {
  const [windowWidth, setWindowWidth] = useState(768);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
  }, []);

  // Center shorter row
  const desktopLogos = useMemo(() => {
    const remainder = section.media?.length % section.amountPerRow;
    const firstSet = section.media?.slice(0, remainder);
    const lastSet = section.media?.slice(remainder, section.media?.length);

    return (
      <>
        {firstSet?.length > 0 && (
          <div
            className={styles.logoGrid}
            style={{
              '--amountPerRow': remainder || 6,
            }}
          >
            {firstSet?.map((logo, j) => {
              return <img key={j} src={logo.file.url} alt={logo.title} />;
            })}
          </div>
        )}
        {lastSet?.length > 0 && (
          <div
            className={styles.logoGrid}
            style={{
              '--amountPerRow': section.amountPerRow,
            }}
          >
            {lastSet.map((logo, j) => {
              return <img key={`last-${j}`} src={logo.file.url} alt={logo.title} />;
            })}
          </div>
        )}
      </>
    );
  }, [section]);

  const mobileLogos = (
    <div
      className={styles.logoGrid}
      style={{
        '--amountPerRowMobile': Math.floor(section.amountPerRow / 2) || 3,
      }}
    >
      {section.media?.map((logo, j) => {
        return <img key={j} src={logo.file.url} alt={logo.title} />;
      })}
    </div>
  );

  return (
    <PageSection slim className={[styles.adjust, styles[section.backgroundColor]].join(' ')}>
      <div
        data-analytics-component={'logo-section'}
        data-analytics-id={section.title}
        className={[styles.logos, !section.alignment ? styles.centered : ''].join(' ')}
      >
        <h2>{section.title}</h2>
        {windowWidth >= 768 ? desktopLogos : mobileLogos}
        {section.ctaLabel && (
          <div className={styles.logoCta}>
            <ArrowLink label={section.ctaLabel} url={section.ctaUrl} />
          </div>
        )}
      </div>
    </PageSection>
  );
};

LogoSection.propTypes = {
  /** A Media Group page section **/
  section: PropTypes.object.isRequired,
};

export default LogoSection;
